export default __webpack_public_path__ + "static/media/ic_share_24px.190c6819.svg";